import React, { useEffect, useMemo, useState } from 'react';

import { useAllRules } from 'src/services/rules';

import { bugsnagNotify } from 'src/lib/bugsnag';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';

import EnableToggle from './TableCells/EnableToggle';
import MoreActions from './TableCells/MoreActions';
import Name from './TableCells/Name';
import Projects from './TableCells/Projects';
import Services from './TableCells/Services';
import NoRules from './NoRules';
import TableHeading from './TableHeading';

import './index.css';

const RulesTableView = ({ rules, setQuery }) => {
  const renderedRules = rules.map(r => {
    return (
      <tr key={r.id} data-cy={`rule-table-row-${r.id}`}>
        <td><Name {...r}/></td>
        <td><Services {...r}/></td>
        <td><Projects {...r}/></td>
        <td><EnableToggle {...r}/></td>
        <td><MoreActions {...r}/></td>
      </tr>
    );
  });

  return (
    <div className="rules-table">
      <TableHeading setQuery={setQuery}/>
      {rules.length === 0 && <NoRules/>}
      {rules.length > 0 && <table>
        <thead>
          <tr>
            <th style={{ width: '20%' }}>Name</th>
            <th>Services</th>
            <th>Projects</th>
            <th style={{ width: '5%', whiteSpace: 'nowrap', minWidth: '50px' }}>Enable</th>
            <th style={{ width: '5%', whiteSpace: 'nowrap', minWidth: '50px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {renderedRules}
        </tbody>
      </table>}
    </div>
  );
};

//TODO: remove that after pagination support
//JIRA: https://pagerduty.atlassian.net/browse/ITS-4964
const LimitationsInfo = ({ rules }) => {
  if (!Array.isArray(rules)) rules = [];
  const v3RulesCount = rules.reduce((acc, r) => acc + (r.isV3Rule ? 1 : 0), 0);
  const totalRules = rules.length;

  const messages = [];
  if (v3RulesCount >= 100) messages.push('We can show ony 100 (legacy) rules right now. We are working on getting more rules for you.');
  if (totalRules >= 500) messages.push('We dont paginate rules right now, but we was informed about so large page you see.');

  useEffect(() => {
    if (v3RulesCount > 100) {
      bugsnagNotify(`user hit 100 rules limit for legacy integration`);
    }
    if (totalRules >= 500) {
      bugsnagNotify(`we display more then 500 rules for some user at the one page.`);
    }
  }, [v3RulesCount, totalRules]);

  return (
    <div style={{ marginTop: 10 }}>
      {messages.map((m, i) => <div key={i} style={{ color: 'darkgoldenrod' }}>{m}</div>)}
    </div>
  );
};

const RulesTable = () => {
  const { rules, error, loading } = useAllRules();
  const [query, setQuery] = useState('');

  const filteredRules = useMemo(() => rules.filter(r => r && typeof r.name === 'string' && r.name.toLowerCase().includes(query.toLowerCase())), [rules, query]);

  if (error) return <ErrorMessage error={['Failed to load Rules', error]}/>;
  if (loading) return <CenteredSpinner size="large"/>;

  return (
    <>
      <RulesTableView {...{ rules: filteredRules, setQuery }}/>
      <LimitationsInfo rules={rules}/>
    </>
  );
};

export default RulesTable;
